import React, { Component } from 'react';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { setUser, updateUser, createUser, getUser } from 'context/actions/index';
import UserProfile from 'components/User/UserProfile';
import { FaUser, FaCheck, FaExclamationCircle } from 'react-icons/fa';
import 'assets/User.css';

class UserPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstTime: false,
      submitted: false,
      done: false
    };
  }

  componentDidMount() {
    // Check if user exists in local storage

    const userData = JSON.parse(localStorage.getItem("user-data"));
    const user = this.props.getUser(userData.user_id)
    if (user.length==0) {
        this.setState({ firstTime: true });
    }
  }

  handleClose = () => {
    this.setState({ firstTime: false, submitted: false });
  };

  handleShow = () => {
    this.setState({ firstTime: true });
  };

  handleDone = () => {
    this.setState({ done: true });
  };

  handleSubmitSuccess = () => {
    this.setState({ submitted: true });
  };

  render() {
    if (this.state.done) {
      return <Navigate to={"/"} />;
    }

    const userData = JSON.parse(localStorage.getItem("user-data"));

    return (
      <React.Fragment>
        {/* Welcome Modal for New Users */}
        <Modal
          show={this.state.firstTime}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          centered
          className="modern-modal"
        >
          <Modal.Header className="bg-primary text-white">
            <Modal.Title>
              <FaUser size={24} className="me-2" />
              Welcome New User
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center py-4">
            <FaExclamationCircle size={48} className="text-primary mb-3" />
            <h5>Let's Complete Your Profile</h5>
            <p className="text-muted">
              Please complete your profile information to get the best experience
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose}>
              Get Started
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Success Modal */}
        <Modal
          show={this.state.submitted}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          centered
          className="modern-modal"
        >
          <Modal.Header className="bg-success text-white">
            <Modal.Title>
              <FaCheck size={24} className="me-2" />
              Success
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center py-4">
            <FaCheck size={48} className="text-success mb-3" />
            <h5>Profile Updated Successfully!</h5>
            <p className="text-muted">Your changes have been saved</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={this.handleDone}>
              Back to Home
            </Button>
            <Button variant="outline-secondary" onClick={this.handleClose}>
              Stay Here
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Main Content */}
        <Container className="my-5 modern-user-container">
          <Row className="justify-content-center">
            <Col lg={8}>
              {/* Pass Redux actions to UserProfile via props */}
              <UserProfile 
                {...this.props}
                onSuccess={this.handleSubmitSuccess}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    book: state.book
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => dispatch(setUser(user)),
    createUser: (user) => dispatch(createUser(user)),
    updateUser: (user) => dispatch(updateUser(user)),
    getUser: (user) => dispatch(getUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPage);